import AuthenticatedTemplate from "../components/AuthenticatedTemplate";
import { loginRequest } from "../authConfig";
import { useMsal } from "@azure/msal-react";
import { getTokenClaims } from "../utils/claimUtils";

import React, { useState, useEffect } from "react";
import axios from "axios";
import { useCustomerInfoB2CStore } from "../stores/customerLoginInfo-store";

import { Dashboard01Welcome } from "./dashboards-flow/Dashboard01Welcome";
import { DashboardReturn } from "./DashboardReturn";
import { Dashboard04Organisations } from "./dashboards-flow/Dashboard04Organisations";

/***
 * Component to detail ID token claims with a description for each claim. For more details on ID token claims, please check the following links:
 * ID token Claims: https://docs.microsoft.com/en-us/azure/active-directory/develop/id-tokens#claims-in-an-id-token
 * Optional Claims:  https://docs.microsoft.com/en-us/azure/active-directory/develop/active-directory-optional-claims#v10-and-v20-optional-claims-set
 */

export const Home = () => {
  const [redirectPage, setRedirectPage] = useState(<Dashboard01Welcome />);
  const { setCustomerInfoB2C } = useCustomerInfoB2CStore();
  const { instance } = useMsal();

  useEffect(() => {
    const checkAccount = async () => {
      try {
        const response = await instance.handleRedirectPromise();
        if (response) {
          instance.setActiveAccount(response.account);
        }

        const account = instance.getActiveAccount();

        if (account) {
          getCustomerEmailClaimReturn(account);
        } else {
          handleLoginRedirect();
        }
      } catch (error) {
        console.error("Login error:", error);
      }
    };

    checkAccount();
  }, []);

  async function handleLoginRedirect() {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  }

  async function getCustomerEmailClaimReturn(account) {
    if (account && account !== "undefined") {
      localStorage.removeItem("LS_ORDER_ID");
      localStorage.removeItem("LS_ORGANISATIONS_LIST");

      const tokenClaimsArray = getTokenClaims(account.idTokenClaims);
      const [givenName, familyName, userEmail, displayName] = [
        tokenClaimsArray[0]?.[1] || "",
        tokenClaimsArray[1]?.[1] || "",
        tokenClaimsArray[2]?.[1] || "",
        tokenClaimsArray[3]?.[1] || "",
      ];
      // const givenName = "Israel";
      // const familyName = "Ruas";
      // const userEmail = "israel.quick@outlook.com";
      // const displayName = "Israel QuickMove";

      const fullName = `${givenName} ${familyName}`.trim();

      setCustomerInfoB2C("email", userEmail);
      setCustomerInfoB2C(
        "displayName",
        displayName !== "unknown" ? displayName : givenName
      );
      setCustomerInfoB2C("fullName", fullName);

      await fetchRedirectPage(userEmail);
    } else {
      console.warn("No active account or undefined account detected.");
    }
  }

  async function fetchRedirectPage(email) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/general/redirect-page`,
        {
          email,
        }
      );
      if (response && response.data) {
        const { message } = response.data;
        if (message === "Payment Pending") {
          sessionStorage.setItem(
            "LS_ORDER_EXIST",
            JSON.stringify(response.data.customerOrder)
          );
          populateLocalStorageOrder(response.data.customerOrder);
        }
        loadPage(message);
      } else {
        console.log("Empty data");
      }
    } catch (error) {
      console.error(
        "Error during customer retrieving",
        error.response?.data || error.message
      );
    }
  }

  function populateLocalStorageOrder(orderArray) {
    const {
      Order_ID,
      Select_Address,
      Select_Name,
      Select_Gender,
      Select_Mobile,
      Select_Email,
      From_Given_Name,
      From_Middle_Name,
      From_Family_Name,
      To_Given_Name,
      To_Middle_Name,
      To_Family_Name,
      From_Gender,
      To_Gender,
      From_Email,
      To_Email,
      From_Mobile_Number,
      To_Mobile_Number,
      Move_Out_Date,
      Move_In_Date,
      From_Address_Building_Name,
      From_Address_Unit_Number,
      From_Address_Street_Number,
      From_Address_Street_Name,
      From_Address_Suburb,
      From_Address_City,
      From_Address_State_Region,
      From_Address_Country,
      From_Address_Post_Code,
      To_Address_Building_Name,
      To_Address_Unit_Number,
      To_Address_Street_Number,
      To_Address_Street_Name,
      To_Address_Suburb,
      To_Address_City,
      To_Address_State_Region,
      To_Address_Country,
      To_Address_Post_Code,
      Consent_Given,
      Consent_Version,
      Consent_Content,
      Attached_File,
    } = orderArray;

    const concatAddress = (addressObj) =>
      Object.values(addressObj)
        .filter((value) => value && value.trim() !== "")
        .join(", ");

    const addressFromArray = {
      Local_Address_Building_Name: From_Address_Building_Name,
      Local_Address_Unit_Number: From_Address_Unit_Number,
      Local_Address_Street_Number: From_Address_Street_Number,
      Local_Address_Street_Name: From_Address_Street_Name,
      Local_Address_Suburb: From_Address_Suburb,
      Local_Address_City: From_Address_City,
      Local_Address_State_Region: From_Address_State_Region,
      Local_Address_Country: From_Address_Country,
      Local_Address_Post_Code: From_Address_Post_Code,
    };

    const addressToArray = {
      Local_Address_Building_Name: To_Address_Building_Name,
      Local_Address_Unit_Number: To_Address_Unit_Number,
      Local_Address_Street_Number: To_Address_Street_Number,
      Local_Address_Street_Name: To_Address_Street_Name,
      Local_Address_Suburb: To_Address_Suburb,
      Local_Address_City: To_Address_City,
      Local_Address_State_Region: To_Address_State_Region,
      Local_Address_Country: To_Address_Country,
      Local_Address_Post_Code: To_Address_Post_Code,
    };

    const listDetails = {
      addressFromStr: concatAddress(addressFromArray),
      addressToStr: concatAddress(addressToArray),
      addressFromArray: addressFromArray,
      addressToArray: addressToArray,
      moveOutDate: Move_Out_Date,
      moveInDate: Move_In_Date,
      emailFrom: From_Email,
      emailTo: To_Email,
      givenNameFrom: From_Given_Name,
      givenNameTo: To_Given_Name,
      middleNameFrom: From_Middle_Name,
      middleNameTo: To_Middle_Name,
      familyNameFrom: From_Family_Name,
      familyNameTo: To_Family_Name,
      mobileNumberFrom: From_Mobile_Number,
      mobileNumberTo: To_Mobile_Number,
      genderFromDesc: "",
      genderToDesc: "",
      genderFromId: From_Gender,
      genderToId: To_Gender,
      documents: Attached_File ? Attached_File.split(";") : [],
      datesToString: {
        moveOutDate: Move_Out_Date || "",
        moveInDate: Move_In_Date || "",
      },
    };

    const consentDetails = {
      given: Consent_Given,
      version: Consent_Version,
      content: Consent_Content,
    };

    var selectedItems = [];
    if (Select_Address) selectedItems.push("address");
    if (Select_Name) selectedItems.push("name");
    if (Select_Gender) selectedItems.push("gender");
    if (Select_Mobile) selectedItems.push("mobileNumber");
    if (Select_Email) selectedItems.push("emailAddress");

    sessionStorage.setItem("LS_DETAILS", JSON.stringify(listDetails));
    sessionStorage.setItem("LS_CHECKED_ITEMS", JSON.stringify(selectedItems));
    sessionStorage.setItem("LS_ORDER_ID", JSON.stringify(Order_ID));
    sessionStorage.setItem(
      "LS_CONSENT_DETAILS",
      JSON.stringify(consentDetails)
    );
  }

  function loadPage(message) {
    const redirectPageMapping = {
      "No customer in DB": <Dashboard01Welcome />,
      "No orders in DB": <Dashboard01Welcome />,
      "Payment Pending": <Dashboard04Organisations />,
      "Fully Paid": <DashboardReturn />,
      "Order Completed": <DashboardReturn />,
    };
    const redirectPageName = redirectPageMapping[message];
    if (redirectPageName) {
      setRedirectPage(redirectPageName);
    }
  }

  return (
    <>
      <AuthenticatedTemplate>{redirectPage}</AuthenticatedTemplate>
    </>
  );
};
